"use client";

import { MoveRightIcon } from "lucide-react";
import { cva, VariantProps } from "class-variance-authority";

import TrackedCtaLink from "@/components/analytics/TrackedCtaLink";

const variants = cva("flex p-2", {
	variants: {
		intent: {
			inline: "",
			ending: "w-full justify-end",
		},
	},
	defaultVariants: {
		intent: "ending",
	},
});

type Props = VariantProps<typeof variants> & {
	label: string;
	href: string;
	className?: string;
	ctaId?: string;
	ctaLocation?: string;
};

export default function ArrowLabel({
	label,
	href,
	className,
	intent,
	ctaId = "arrow_label",
	ctaLocation = "arrow_label",
}: Props) {
	return (
		<TrackedCtaLink
			href={href}
			ctaId={ctaId}
			ctaName={label}
			ctaLocation={ctaLocation}
			className={variants({ className, intent })}
		>
			<h1 className="mt-0.5 px-2 text-xsm2 font-semibold">{label}</h1>
			<MoveRightIcon />
		</TrackedCtaLink>
	);
}
